import { render, staticRenderFns } from "./facilitiesSearchForm.vue?vue&type=template&id=2b3ab5ab&"
import script from "./facilitiesSearchForm.vue?vue&type=script&lang=js&"
export * from "./facilitiesSearchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports